/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import { CuratedSearch } from "./CuratedSearchComponent";
import { InputHandle } from "./InputHandle";
import { SEARCH_OPTIONS, TEXT_TYPES } from "../../../constants/APP_CONSTANTS";
import ReactTable from "react-table";
import moment from "moment";
import _ from "lodash";
import { Scrollbars } from "react-custom-scrollbars";
import config from "../../../config";
import { SelectedPreview } from "./SelectedPreview";
import { UpdateEnvironment } from "./UpdateEnvironment";
import { UpdateMetaData } from "./UpdateMetaData";
import Svg from "../../widgets/Svg/Svg";

import AxiosClient from "../../../_helpers/http.helper";
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";

export default class CuratedContentManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resultSet: {
                curatedCollectionDTOList: []
            },
            inputHandle: {
                searchParam: "",
                searchValue: "",
                placeholder: SEARCH_OPTIONS.FILTER,
                searchEnabled: false
            },
            showResults: false,
            pageSize: 5,
            selected: {},
            selectAll: 0,
            selectedAtleastOne: false,
            showModal: false,
            selectedRow: {},
            scrubbedStatus: null,
            missingCollectionData: null,
            selectedCourseCodes: null,
            showSecondModal: false,
            showLoader: false,
            secondModalDetail: {
                header: "Error",
                message: "Error",
                shouldRefreshSearch: false
            },
            keywords: ""
        };
        this.updateSearchParams = this.updateSearchParams.bind(this);
        this.updateSearchValues = this.updateSearchValues.bind(this);
        this.curatedSearch = this.curatedSearch.bind(this);
    }

    resetResults = () => {
        this.setState({
            ...this.state,
            selectedAtleastOne: false,
            selectAll: false,
            selected: {},
            resultSet: null
        });
    };

    curatedSearch() {
        this.resetResults();
        this.setState({
            resultSet: {
                curatedCollectionDTOList: []
            },
            selectedAtleastOne: false,
            missingCollectionData: null,
            showResults: false,
            showLoader: true
        });
        const params = {
            searchParam: this.state.inputHandle.searchParam,
            searchValue: this.state.inputHandle.searchValue
        };

        this.getResources(params).then(response => {
            this.setStateData(response);
            let collectionArr = [];
            response.map(curatedCollection => {
                collectionArr.push(
                    curatedCollection.parentCollection.collectionId
                );
            });
            this.getMissingData(collectionArr);
        });
    }

    deselectAll = () => {
        this.setState({
            selectedAtleastOne: false,
            selectAll: false,
            selected: {}
        });
    };

    setStateData = data => {
        this.setState(() => {
            const items = {};
            data.map(cc => {
                cc.scrubbed = cc.unscrubbed === false;
                return cc;
            }).forEach(cc =>
                items[cc.isbn]
                    ? items[cc.isbn].push(cc)
                    : (items[cc.isbn] = [cc])
            );

            const mergedItems = Object.values(items).map(itemsList => {
                if (itemsList.length > 1) {
                    itemsList[0].scrubbed = true;
                    itemsList[0].unscrubbed = true;
                }
                return itemsList[0];
            });

            const result = [].concat(...mergedItems);
            return {
                resultSet: {
                    curatedCollectionDTOList: result
                },
                showLoader: false
            };
        });
    };

    updateSearchParams = params => {
        this.setState(prevState => {
            return {
                ...prevState,
                selected: {},
                resultSet: {
                    curatedCollectionDTOList: []
                },
                inputHandle: {
                    ...prevState.inputHandle,
                    searchValue: "",
                    searchParam: params.searchParam,
                    placeholder: params.placeholder,
                    searchEnabled: params.searchEnabled
                },
                showResults: false
            };
        });
    };

    updateSearchValues = searchValue => {
        this.setState(prevState => {
            return {
                inputHandle: {
                    ...prevState.inputHandle,
                    searchEnabled: true,
                    searchValue: searchValue
                }
            };
        });
    };

    getResources = options => {
        const searchUrlBase
            = config.collectionService.baseUrl
            + config.collectionService.routes.curatedSearch;

        switch (options.searchParam) {
            case "title": {
                const url = searchUrlBase + "title";
                const title = options.searchValue.trim();
                return AxiosClient.request({
                    method: "POST",
                    headers: { "Content-Type": "text/plain" },
                    url,
                    data: title
                }).then(res => {
                    return res.data;
                });
            }

            case "isbn": {
                const url = searchUrlBase + "isbn";
                const isbns = options.searchValue.replace(/\s/g, "").split(",");
                const payload = [];
                isbns.map(isbn => {
                    if(isbn.trim() !== ""){
                        payload.push(isbn);
                    }
                });
                return AxiosClient.post(url, payload).then(res => res.data);
            }
            default:
        }
    };

    getMissingData = collectionIds => {
        const baseUrl
            = config.collectionService.baseUrl
            + config.collectionService.routes.missingCollectionInfo;
        return AxiosClient.post(baseUrl, collectionIds).then(res => {
            setTimeout(() => {
                this.setState({
                    missingCollectionData: res.data,
                    showResults: true
                });
            }, 100);
        });
    };

    toggleRow = obj => {
        const { selected } = this.state;
        const newSelected = Object.assign({}, selected);
        newSelected[obj.curatedCollectionId] = !selected[
            obj.curatedCollectionId
        ];
        this.setState({
            selected: newSelected
        });

        if (newSelected[obj.curatedCollectionId]) {
            this.setState({
                selectedAtleastOne: true
            });
        } else {
            const status = _.findKey(newSelected, item => {
                return item === true;
            });
            const removeTick = _.findKey(newSelected, item => {
                return item === false;
            });

            if (status) {
                this.setState({
                    selectedAtleastOne: true
                });
            } else {
                this.setState({
                    selectedAtleastOne: false
                });
            }
            if (removeTick != null) {
                this.setState({
                    selectAll: false
                });
            }
        }
    };

    toggleAll = () => {
        const newSelected = Object.assign({}, this.state.selected);

        this.state.resultSet.curatedCollectionDTOList.map(obj => {
            newSelected[obj.curatedCollectionId] = !this.state.selectAll;
        });

        this.setState({
            selected: newSelected,
            selectAll: !this.state.selectAll,
            selectedAtleastOne: !this.state.selectAll
        });
    };

    generateLastModifiedDate = lastModified => {
        return moment(lastModified)
            .local()
            .format("MM-DD-YYYY");
    };

    hideModal = () => {
        this.setState({
            showModal: false,
            selectedRow: {}
        });
    };

    closeSecondModal = () => {
        this.setState({
            showSecondModal: false
        }, () => {
            if (this.state.secondModalDetail.shouldRefreshSearch) {
                this.curatedSearch();
            }
        });
    };

    showSecondModal = (header, message, shouldRefreshSearch = false) => {
        this.setState({
            showSecondModal: true,
            secondModalDetail: {
                header: header,
                message: message,
                shouldRefreshSearch: shouldRefreshSearch
            }
        });
    };

    renderResultsTable = () => {
        const columns = [
            {
                Header: () => {
                    return (
                        <div className="pe-checkbox" onClick={this.toggleAll}>
                            <input
                                type="checkbox"
                                id="checkboxInput"
                                value="1"
                                checked={this.state.selectAll}
                                onChange={() => {}}
                            />
                            <span>
                                <svg
                                    aria-hidden="true"
                                    focusable="false"
                                    className="pe-icon--check-sm-18"
                                >
                                    <use xlinkHref="#check-sm-18" />
                                </svg>
                            </span>
                        </div>
                    );
                },
                Cell: row => (
                    <div
                        className="pe-checkbox"
                        onClick={() => {
                            this.toggleRow(row.original);
                        }}
                    >
                        <input
                            type="checkbox"
                            id="checkboxInput"
                            checked={
                                !!this.state.selected[
                                    row.original.curatedCollectionId
                                ]
                            }
                            onChange={() => {}}
                        />
                        <span>
                            <svg
                                aria-hidden="true"
                                focusable="false"
                                className="pe-icon--check-sm-18"
                            >
                                <use xlinkHref="#check-sm-18" />
                            </svg>
                        </span>
                    </div>
                ),
                width: 50
            },
            {
                Header: "Title",
                accessor: "parentCollection.title",
                sortable: true
            },
            {
                Header: "ISBN 10",
                accessor: "parentCollection.isbn10",
                sortable: true
            },
            {
                Header: "ISBN 13",
                accessor: "isbn",
                sortable: true
            },
            {
                Header: "Keywords",
                accessor: "keywords",
                sortable: true
            },
            {
                Header: "Last Edit",
                accessor: "parentCollection.lastModified",
                sortable: true,
                Cell: data => {
                    return this.generateLastModifiedDate(
                        data.original.parentCollection.lastModified
                    );
                }
            },
            {
                Header: "Collection ID",
                accessor: "parentCollection.collectionId",
                sortable: true
            },
            {
                Header: "Scrubbed",
                accessor: "scrubbed",
                Cell: v => (v.value ? "True" : "False"),
                sortable: true
            },
            {
                Header: "Unscrubbed",
                accessor: "unscrubbed",
                Cell: v => (v.value ? "True" : "False"),
                sortable: true
            },
            {
                Header: "Visible",
                accessor: "parentCollection.sharing",
                sortable: true,
                Cell: data =>
                    data.original.parentCollection.sharing === "Public" ? (
                        <Svg svgString={"show-on-18"} />
                    ) : (
                        <Svg svgString={"show-off-18"} />
                    )
            }
        ];

        return (
            <div>
                <div className="table-wrap">
                    <Scrollbars
                        autoHeight
                        autoHeightMin={200}
                        autoHeightMax={600}
                    >
                        <ReactTable
                            className="-highlight"
                            showPagination={false}
                            data={this.state.resultSet.curatedCollectionDTOList}
                            columns={columns}
                            minRows={0}
                            sortable={false}
                            pageText=""
                            noDataText={TEXT_TYPES.RESOURCE_NOT_FOUND}
                            defaultPageSize={1000}
                            getTdProps={(state, rowInfo, column) => {
                                return {
                                    style: {
                                        cursor: "pointer",
                                        backgroundColor: rowInfo.original
                                            .keywordSerach
                                            ? "#ddd"
                                            : "initial"
                                    },
                                    onClick: () => {
                                        if (
                                            typeof column.Header !== "function"
                                        ) {
                                            this.setState({
                                                showModal: true,
                                                selectedRow:
                                                    rowInfo.original
                                                        .parentCollection,
                                                scrubbedStatus:
                                                    rowInfo.original.unscrubbed,
                                                keywords: rowInfo.original
                                                    .keywords
                                                    ? rowInfo.original.keywords
                                                    : "",
                                                selectedCourseCodes: this.state
                                                    .missingCollectionData[
                                                        rowInfo.original
                                                            .parentCollection
                                                            .collectionId
                                                    ]
                                            });
                                        }
                                    }
                                };
                            }}
                        />
                    </Scrollbars>
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="CMM-container pe-row">
                <div className="content-home-page">
                    <label className="pe-page-title--small search-title">
                        {" "}
                        {TEXT_TYPES.CURATED_SEARCH}{" "}
                    </label>
                    <hr />

                    <div className="pe-row ">
                        <div className="pe-col-4 ">
                            <CuratedSearch
                                updateSearchParams={e =>
                                    this.updateSearchParams(e)
                                }
                            />
                        </div>

                        <div className="pe-col-6 ">
                            <InputHandle
                                updateSearchValues={e =>
                                    this.updateSearchValues(e)
                                }
                                options={this.state.inputHandle}
                                triggerSearch={this.curatedSearch}
                            />
                        </div>

                        <div className="pe-col-2 ">
                            <button
                                className="pe-btn"
                                onClick={this.curatedSearch}
                                disabled={
                                    this.state.inputHandle.searchValue
                                        ? false
                                        : true
                                }
                            >
                                Search
                            </button>
                        </div>
                    </div>
                </div>

                {this.state.showLoader ? (
                    <div style={{ marginTop: "20px" }}>
                        <LoadingIndicator />
                    </div>
                ) : this.state.showResults ? (
                    this.renderResultsTable()
                ) : (
                    ""
                )}

                {this.state.selectedAtleastOne  ? (
                    <div>
                        <SelectedPreview
                            selected={this.state.selected}
                            items={
                                this.state.resultSet.curatedCollectionDTOList
                            }
                            deselect={this.deselectAll}
                        />
                        <UpdateEnvironment
                            selected={this.state.selected}
                            items={
                                this.state.resultSet.curatedCollectionDTOList
                            }
                            refreshSearch={this.curatedSearch}
                        />
                    </div>
                ) : (
                    ""
                )}
                {this.state.showModal ? (
                    <UpdateMetaData
                        showSecondModal={this.showSecondModal}
                        showModal={this.state.showModal}
                        hideModal={this.hideModal}
                        selectedRow={this.state.selectedRow}
                        courses={this.state.selectedCourseCodes}
                        scrubbedStatus={this.state.scrubbedStatus}
                        keywords={this.state.keywords}
                    />
                ) : (
                    ""
                )}

                {this.state.showSecondModal ? (
                    <ModalDialog
                        title={this.state.secondModalDetail.header}
                        successText={"Ok"}
                        showModal={this.state.showSecondModal}
                        showCancel={false}
                        onSuccess={this.closeSecondModal}
                        onCancel={this.closeSecondModal}
                    >
                        <div>{this.state.secondModalDetail.message}</div>
                    </ModalDialog>
                ) : (
                    ""
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/CuratedSearch/CuratedContentManagement.js